import { render, staticRenderFns } from "./second_videoList.vue?vue&type=template&id=048ff364&scoped=true&"
import script from "./second_videoList.vue?vue&type=script&lang=js&"
export * from "./second_videoList.vue?vue&type=script&lang=js&"
import style0 from "./second_videoList.vue?vue&type=style&index=0&id=048ff364&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ff364",
  null
  
)

export default component.exports